import React from "react";
import PropTypes from "prop-types";

import classnames from "classnames";

const ToolTip = ({
  children,
  className,
  position = "top",
  isActive = true,
  id = "",
}) => {
  const componentBaseClass = "sal-tooltip";
  const statusSuffix = isActive ? "visible" : "hidden";
  const componentClass = classnames(
    componentBaseClass,
    `${componentBaseClass}--${statusSuffix}`,
    `${componentBaseClass}--${position}`,
    className,
  );

  return (
    <div className={componentClass} role="tooltip" id={id ? id : null}>
      <div className="sal-tooltip__content">{children}</div>
    </div>
  );
};

ToolTip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,

  position: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  isActive: PropTypes.bool,
  id: PropTypes.string,
};

export default ToolTip;
